<div
  id="vn-address-invalid"
  class="errorpage">
  <div class="errorpage-logo-container">
    <img
      src="assets/allianz-logo.png"
      alt="allianz-logo"
      class="errorpage-logo-img" />
  </div>
  <div class="errorpage-content">
    <nx-icon
      name="exclamation-circle-warning"
      outline="false"
      size="m"
      class="errorpage-warn-img"></nx-icon>
    <div class="errorpage-headline">
      <span [innerHTML]="'vnAddressInvalidPage.headline' | html"></span>
    </div>
    <div class="errorpage-msg">{{ "vnAddressInvalidPage.message" | text }}</div>
    <div class="errorpage-msg-bold">
      <div class="content-vn-address-invalid nx-margin-bottom-l nx-margin-top-4m">
        <div class="checkbox-vn-address-invalid nx-margin-bottom-2m">
          <nx-checkbox
            #checkboxRef="ngModel"
            required
            [ngModel]="checkboxChecked"
            (checkedChange)="checkboxChecked = !checkboxChecked"
            [name]="'checkboxVnAddressInvalid'">
            <span [innerHTML]="'vnAddressInvalidPage.checkbox' | html"></span>
          </nx-checkbox>
          @if (checkboxRef.touched && !checkboxChecked) {
            <nx-error
              appearance="text"
              class="has-error nx-margin-top-2xs"
              context="error"
              nxFormfieldError>
              <span [innerHTML]="'vnAddressInvalidPage.validationMessage' | html"></span>
            </nx-error>
          }
        </div>
        <button
          class="nx-margin-bottom-0 nx-margin-right-xs"
          type="button"
          nxButton="medium primary"
          (click)="onGoToShopClick()"
          [id]="'vn-address-invalid-button'">
          {{ "vnAddressInvalidPage.confirmButton" | text }}
        </button>
      </div>
    </div>
    <div class="errorpage-msg">{{ "vnAddressInvalidPage.correlationId" | text }}</div>
    <div class="errorpage-msg-bold">{{ correlationId | async }}</div>
  </div>
</div>
